import type { UseQueryResult } from '@tanstack/react-query';

import { useQuery } from '@tanstack/react-query';

import type { UserNotificationPreferences } from '../../api/types/userNotificationPreferences.types';

import { getUserNotificationPreferences } from '../../api/get-user-notification-preferences/getUserNotificationPreferences';
import {
  PROFILE_GC_TIME_MS,
  PROFILE_STALE_TIME_MS,
} from '../../contexts/ProfileProvider.constants';

export function useUserNotificationPreferences(): UseQueryResult<
  UserNotificationPreferences[],
  Error
> {
  return useQuery<UserNotificationPreferences[], Error>({
    queryKey: ['user-notification-preferences'],
    queryFn: (): Promise<UserNotificationPreferences[]> =>
      getUserNotificationPreferences(),
    staleTime: PROFILE_STALE_TIME_MS,
    gcTime: PROFILE_GC_TIME_MS,
    refetchOnWindowFocus: false,
  });
}
